import React, {useEffect, useRef, useState} from 'react';
import {useHistory, useParams, withRouter} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {NotificationManager} from "react-notifications";
import {sendMatchResults, suspendMatch} from "../../services/matches";
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import ImageCropper from '../ImageCropper/ImageCropper';
import heic2any from 'heic2any';

// React Components
import DialogCard from '../DialogCard';
import InputRadio from "../InputRadio";
import InputTextArea from "../InputTextArea/InputTextArea";

// CSS Files
import './styles.css';

const MySwal = withReactContent(Swal);

const TeamResult = (props) => {
   useEffect(() => {
      if (props.teamA) {
         props.firstSetRef.current.focus();
      }
   }, []);

   return <div className="team-result-container">
      <div className={"game-card-team " + (props.teamA ? "team-a" : "team-b")}>
         <div className="game-card-person">
            <img src={props.team[0].image} alt={props.team[0].name}/>
            <span>{props.team[0].name}</span>
         </div>
         <div className="flex-gap"/>
         <div className="game-card-person">
            <img src={props.team[1].image} alt={props.team[1].name}/>
            <span>{props.team[1].name}</span>
         </div>
      </div>
      <div className="scores-container">
         <div className="score-card">
            <span>1</span>
            <input type="text" onChange={props.onChangeFirstSet} value={props.firstSetScore} ref={props.firstSetRef}/>
         </div>
         <div className="score-card">
            <span>2</span>
            <input type="text" onChange={props.onChangeSecondSet} value={props.secondSetScore} ref={props.secondSetRef}/>
         </div>
         <div className="score-card">
            <span>{props.leagueFormat === "stb" ? "STB" : "3"}</span>
            <input type="text" onChange={props.onChangeThirdSet} value={props.thirdSetScore} ref={props.thirdSetRef} disabled={(props.leagueFormat === "stb" && !props.isDraw)}/>
         </div>
      </div>
   </div>;
};

const ResultsDialog = (props) => {
   const hiddenFileInput = React.useRef(null);
   const [inputFile, setInputFile] = useState(null);
   const [teamAScores, setTeamAScores] = useState({firstSet: '', secondSet: '', thirdSet: ''});
   const [teamBScores, setTeamBScores] = useState({firstSet: '', secondSet: '', thirdSet: ''});
   const [isSending, setIsSending] = useState(false);
   const [showCropper, setShowCropper] = useState(false);
   const [imageToCrop, setImageToCrop] = useState(null);
   const [noAttendance, setNoAttendance] = useState(false);
   const history = useHistory();
   const { t } = useTranslation();
   let {matchId} = useParams();
   let isDraw = (teamAScores.firstSet > teamBScores.firstSet && teamAScores.secondSet < teamBScores.secondSet) ||
      (teamAScores.firstSet < teamBScores.firstSet && teamAScores.secondSet > teamBScores.secondSet);
   const matchPhotoAspectOptions = [
      { label: 'Landscape', value: 4 / 3, icon: 'landscape' },
      { label: 'Square', value: 1, icon: 'square' },
      { label: 'Portrait', value: 3 / 4, icon: 'portrait' },
   ];

   const firstSetARef = useRef();
   const firstSetBRef = useRef();
   const secondSetARef = useRef();
   const secondSetBRef = useRef();
   const thirdSetARef = useRef();
   const thirdSetBRef = useRef();

   const fileInputBackground = () => {
      if (!inputFile) return {};
      return {backgroundImage: 'url(' + URL.createObjectURL(inputFile) + ')'};
   };

   const validateScores = () => {
      let set_1_valid = false;
      let set_2_valid = false;
      let set_3_valid = true;

      const possible_match_results = [[6, 0], [6, 1], [6, 2], [6, 3], [6, 4], [7, 5], [7, 6], [0, 6], [1, 6], [2, 6], [3, 6], [4, 6], [5, 7], [6, 7]];

      if (props.leagueFormat === "third_set") {
         if (teamAScores.firstSet === '' || teamBScores.firstSet === '' || teamAScores.secondSet === '' || teamBScores.secondSet === '' || teamAScores.thirdSet === '' || teamBScores.thirdSet === '') {
            NotificationManager.error(t("scheduled_page.errors.mandatory_fields"), t("common.attention"), 4000);
            return false;
         } else {
            set_3_valid = false

            for (const result of possible_match_results) {
               if (teamAScores.firstSet == result[0] && teamBScores.firstSet == result[1]) {
                  set_1_valid = true;
               }

               if (teamAScores.secondSet == result[0] && teamBScores.secondSet == result[1]) {
                  set_2_valid = true;
               }

               if (teamAScores.thirdSet == result[0] && teamBScores.thirdSet == result[1]) {
                  set_3_valid = true;
               }
            }
         }
      }

      if (props.leagueFormat === "stb") {
         // Se os campos do primeiro ou segundo set não estiverem preenchidos
         if (teamAScores.firstSet === '' || teamBScores.firstSet === '' || teamAScores.secondSet === '' || teamBScores.secondSet === '') {
            NotificationManager.error(t("scheduled_page.errors.empty_sets"), t("common.attention"), 4000);
            return false;
         } else {
            for (const result of possible_match_results) {
               if (teamAScores.firstSet == result[0] && teamBScores.firstSet == result[1]) {
                  set_1_valid = true;
               }

               if (teamAScores.secondSet == result[0] && teamBScores.secondSet == result[1]) {
                  set_2_valid = true;
               }
            }

            if (isDraw) {
               // Os campos de STB devem ser preenchidos
               set_3_valid = false;

               // Validação do STB
               if (teamAScores.thirdSet === '' || teamBScores.thirdSet === '') {
                  NotificationManager.error(t("scheduled_page.errors.mandatory_stb"), t("common.attention"), 4000);
                  return false;
               } else {
                  if (Math.max(teamAScores.thirdSet, teamBScores.thirdSet) === 10 && Math.abs(teamAScores.thirdSet - teamBScores.thirdSet) >= 2) {
                     set_3_valid = true;
                  } else if (Math.max(teamAScores.thirdSet, teamBScores.thirdSet) >= 11 && Math.abs(teamAScores.thirdSet - teamBScores.thirdSet) === 2) {
                     set_3_valid = true;
                  }
               }
            }

            if (!isDraw && (teamAScores.thirdSet !== '' || teamBScores.thirdSet !== '')) {
               setTeamAScores({...teamAScores, thirdSet: ''});
               setTeamBScores({...teamBScores, thirdSet: ''});
               NotificationManager.error(t("scheduled_page.errors.invalid_score"), t("common.attention"), 4000);

               return false;
            }
         }
      }

      if (!set_1_valid) {
         NotificationManager.error(t("scheduled_page.errors.invalid_set_1"), t("common.attention"), 4000)
         return false;
      } else {
         if (!set_2_valid) {
            NotificationManager.error(t("scheduled_page.errors.invalid_set_2"), t("common.attention"), 4000);
            return false;
         } else {
            if (!set_3_valid) {
               switch (props.leagueFormat) {
                  case "stb":
                     NotificationManager.error(t("scheduled_page.errors.invalid_stb"), t("common.attention"), 4000);
                     return false;
                  case "third_set":
                     NotificationManager.error(t("scheduled_page.errors.invalid_set_3"), t("common.attention"), 4000);
                     return false;
               }
            }
         }
      }

      return set_1_valid && set_2_valid && set_3_valid;
   }

   const registerInterruptedMatch = async (matchScore, lastDoubleServe, reason) => {
      try {
         await suspendMatch(matchId, matchScore, lastDoubleServe, reason);
         MySwal.fire({
            text: t("scheduled_page.suspend_match_popup.success"),
            allowOutsideClick: false
         }).then(() => {
            history.push("/my-games");
         })
      } catch (e) {
         NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
      }
   }

   const sendResults = async (matchId, teamAScores, teamBScores, inputFile, noAttendance, noAttendanceReason, noAttendanceDescription, isReschedule) => {
      try {
         setIsSending(true);
         await sendMatchResults(matchId, teamAScores, teamBScores, inputFile, noAttendance, noAttendanceReason, noAttendanceDescription, isReschedule);

         MySwal.fire({
            allowOutsideClick: false,
            titleText: t("common.success"),
            text: t("scheduled_page.result_success")
         }).then(async (res) => {
            history.push("/my-games");
         });
      } catch {
         setIsSending(false);
      }
   }

   return <DialogCard title={t("scheduled_page.result")}>
      <div className={"results-form-wrapper"}>
         <div className="results-wrapper">
            <TeamResult
               teamA
               team={props.teams.a}
               isDraw={isDraw}
               leagueFormat={props.leagueFormat}
               firstSetScore={teamAScores.firstSet}
               secondSetScore={teamAScores.secondSet}
               thirdSetScore={teamAScores.thirdSet}
               onChangeFirstSet={(e) => {
                  setTeamAScores({...teamAScores, firstSet: e.target.value});
                  if (!isNaN(parseInt(e.target.value))) {
                     firstSetBRef.current.focus();
                  }
               }}
               onChangeSecondSet={(e) => {
                  setTeamAScores({...teamAScores, secondSet: e.target.value})
                  if (!isNaN(parseInt(e.target.value))) {
                     secondSetBRef.current.focus();
                  }
               }}
               onChangeThirdSet={(e) => {
                  setTeamAScores({...teamAScores, thirdSet: e.target.value})
                  if (props.leagueFormat === "third_set") {
                     thirdSetBRef.current.focus();
                  }
               }}
               firstSetRef={firstSetARef}
               secondSetRef={secondSetARef}
               thirdSetRef={thirdSetARef}
            />
            <hr style={{width: "calc(100% - 40px)"}}/>
            <TeamResult
               teamA={false}
               team={props.teams.b}
               isDraw={isDraw}
               leagueFormat={props.leagueFormat}
               firstSetScore={teamBScores.firstSet}
               secondSetScore={teamBScores.secondSet}
               thirdSetScore={teamBScores.thirdSet}
               onChangeFirstSet={(e) => {
                  setTeamBScores({...teamBScores, firstSet: e.target.value});
                  if (!isNaN(parseInt(e.target.value))) {
                     secondSetARef.current.focus();
                  }
               }}
               onChangeSecondSet={(e) => {
                  setTeamBScores({...teamBScores, secondSet: e.target.value})
                  if (props.leagueFormat === "third_set") {
                     thirdSetARef.current.focus();
                  }
               }}
               onChangeThirdSet={(e) => {
                  setTeamBScores({...teamBScores, thirdSet: e.target.value})
               }}
               firstSetRef={firstSetBRef}
               secondSetRef={secondSetBRef}
               thirdSetRef={thirdSetBRef}
            />
         </div>
         <div className="results-photo-wrapper">
            <div className={"results-photo" + (inputFile ? " has-photo" : "")}
                 onClick={() => {
                    hiddenFileInput.current.click()
                 }}
                 style={fileInputBackground()}>
               <input
                 type="file"
                 ref={hiddenFileInput}
                 style={{ display: "none" }}
                 onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    const isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
                      file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif');
                    try {
                      const source = isHeic
                        ? await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 })
                        : file;
                      const blob = source instanceof Blob ? source : source[0];
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setImageToCrop(reader.result);
                        setShowCropper(true);
                      };
                      reader.readAsDataURL(blob);
                    } catch (err) {
                      console.error('Image load error:', err);
                    }
                 }}
               />
               <div className="results-photo-text-container">
                  <span>{t("scheduled_page.insert_picture")}</span>
               </div>
            </div>
         </div>
         <div className="results-actions">
            {inputFile && <Button onClick={() => setInputFile(null)} className="w-100 mt-1 mb-4 btn-thick" variant={"secondary"}>{t("scheduled_page.remove_picture")}</Button>}
            <Button
              onClick={async () => {
                 if (validateScores() && !isSending) {
                    if (props.leagueFormat === "stb" && ((+teamAScores.firstSet) + (+teamAScores.secondSet) === 0 || (+teamBScores.firstSet) + (+teamBScores.secondSet) === 0)) {
                        let selectedReasonRef = '';
                        let descriptionRef = '';

                        const NoAttendancePopup = () => {
                           const [selectedReason, setSelectedReason] = useState('');
                           const [description, setDescription] = useState('');

                           const reasons = [
                              t("scheduled_page.no_attendance_popup.reasons.didnt_warn"),
                              t("scheduled_page.no_attendance_popup.reasons.cancelled_less_24h"),
                              t("scheduled_page.no_attendance_popup.reasons.couldnt_play"),
                              t("scheduled_page.no_attendance_popup.reasons.other"),
                           ];

                           useEffect(() => {
                              selectedReasonRef = selectedReason
                           }, [selectedReason]);

                           useEffect(() => {
                              descriptionRef = description
                           }, [description]);

                           return <div>
                              <div className={"mb-2"}>
                                 <Form.Label className={"mb-0"}>{t("scheduled_page.no_attendance_popup.reason")}</Form.Label>

                                 {reasons.map((reason, key) => {
                                    return <Form.Check
                                       id={`reason-${key}`}
                                       key={key}
                                       type="radio"
                                       label={reason}
                                       value={reason}
                                       checked={selectedReason === reason}
                                       onChange={(e) => setSelectedReason(e.target.value)}
                                       className={"text-left"}
                                    />
                                 })}
                              </div>

                              <InputTextArea handleChange={(e) => {
                                 setDescription(e.target.value)
                              }} rows={"3"} text={t("scheduled_page.no_attendance_popup.describe_reason")}/>
                           </div>
                        }

                        const CheckNoAttendancePopup = () => {
                           const [noAttendaceRef, setNoAttendanceRef] = useState(noAttendance);

                           return <div>
                              <p className={"mb-3"}>{t("scheduled_page.was_no_attendance_popup.title")}</p>
                              <InputRadio
                                 handleChange={(e) => {
                                    setNoAttendanceRef(!e.target.value);
                                    setNoAttendance(!e.target.value);
                                 }}
                                 name="noAttendance"
                                 firstRadioText={t("scheduled_page.was_no_attendance_popup.match_played")}
                                 secondRadioText={t("scheduled_page.was_no_attendance_popup.no_attendance")}
                                 defaultChecked={!noAttendance}
                              />
                              <Button className={"w-100 mt-4 mb-2 btn-thick"} onClick={async () => {
                                 if (noAttendaceRef) {
                                    await MySwal.fire({
                                       customClass: {
                                          actions: "mt-0"
                                       },
                                       titleText: t("scheduled_page.was_no_attendance_popup.no_attendance"),
                                       html: (
                                          <NoAttendancePopup/>
                                       ),
                                       confirmButtonText: t("common.send"),
                                       preConfirm: async () => {
                                          if (selectedReasonRef === '') {
                                             NotificationManager.error(t("to_schedule_page.errors.no_reason"), t("common.error"), 4000);
                                             return false;
                                          } else if (selectedReasonRef === 'Outra' && descriptionRef === '') {
                                             NotificationManager.error(t("to_schedule_page.errors.no_reason"), t("common.error"), 4000);
                                             return false;
                                          }
                                       }
                                    }).then(async (res) => {
                                       if (res.value) {
                                          await sendMatchResults(matchId, teamAScores, teamBScores, inputFile, noAttendaceRef, selectedReasonRef, descriptionRef);

                                          NotificationManager.success(t("scheduled_page.no_attendance_popup.success"), t("common.success"), 4000);
                                          history.push('/my-games');
                                       }
                                    });
                                 } else {
                                    await sendResults(matchId, teamAScores, teamBScores, inputFile, noAttendaceRef)
                                 }
                              }}>
                                 {t("common.confirm")}
                              </Button>
                              <Button className={"w-100 btn-thick"} onClick={() => MySwal.close()} variant={"secondary"}>{t("common.cancel")}</Button>
                           </div>
                        }
                        await MySwal.fire({
                           customClass: {
                              actions: "mt-0"
                           },
                           titleText: t("scheduled_page.was_no_attendance_popup.title"),
                           html: (
                              <CheckNoAttendancePopup/>
                           ),
                           showConfirmButton: false
                        });
                     } else {
                        await sendResults(matchId, teamAScores, teamBScores, inputFile, noAttendance);
                     }
                  }
               }}
               className="w-100 mt-2 mb-2 btn-thick"
               variant={"primary"}
               disabled={isSending}
            >
               {isSending ? t("common.please_wait") : t("common.save")}
            </Button>
            {props.matchState !== "suspended" && props.matchState !== "played" &&
               <Button
                  className="w-100 mb-2 btn-thick"
                  variant={"secondary"}
                  onClick={() => {
                     MySwal.fire({
                        titleText: t("scheduled_page.suspend_match_popup.title"),
                        html: `<div>
                                <label class='swal-content mb-0'>${t("scheduled_page.suspend_match_popup.prior_score")}</label>
                                <textarea id='matchScore' class='cancel-popup-input d-flex swal2-textarea'></textarea>
                                </div>
                               <div>
                                <label class='swal-content mb-0'>${t("scheduled_page.suspend_match_popup.who_served")}</label>
                                <textarea id='lastDoubleServe' class='cancel-popup-input d-flex swal2-textarea'></textarea>
                               </div>
                               <div>
                                <label class='swal-content mb-0'>${t("scheduled_page.suspend_match_popup.suspension_reason")}</label>
                                <textarea id='reason' class='cancel-popup-input d-flex swal2-textarea mb-0'></textarea>
                               </div>`,
                        showCancelButton: true,
                        cancelButtonText: t("common.cancel"),
                        confirmButtonText: t("common.send"),
                        preConfirm: () => {
                           let matchScore = document.getElementById("matchScore").value;
                           let lastDoubleServe = document.getElementById("lastDoubleServe").value;
                           let reason = document.getElementById("reason").value;

                           if (matchScore === "" || lastDoubleServe === "" || reason === "") {
                              NotificationManager.error(t("scheduled_page.errors.mandatory_fields"), t("common.error"), 4000);
                              return false;
                           }
                        }
                     }).then(async (res) => {
                        if (res.value) {
                           let matchScore = document.getElementById("matchScore").value;
                           let lastDoubleServe = document.getElementById("lastDoubleServe").value;
                           let reason = document.getElementById("reason").value;

                           await registerInterruptedMatch(matchScore, lastDoubleServe, reason);
                        } else if (res.dismiss === MySwal.DismissReason.cancel) {
                           MySwal.close();
                        }
                     })
                  }}
               >
                  {t("scheduled_page.suspend_match_popup.title")}
               </Button>
            }
            <Button onClick={() => props.close()} className="w-100 btn-thick" variant={"secondary"}>{t("common.close")}</Button>
         </div>
      </div>
      {showCropper && (
        <ImageCropper
          image={imageToCrop}
          aspect={4 / 3}
          aspectOptions={matchPhotoAspectOptions}
          onCancel={() => {
             setShowCropper(false);
             setImageToCrop(null);
           }}
          onUpload={async (formData) => {
             return { success: true, photo: formData.get('image') };
          }}
          onUploadSuccess={(croppedBlob) => {
             setInputFile(croppedBlob);
             setShowCropper(false);
          }}
        />
      )}
   </DialogCard>;
};

export default withRouter(ResultsDialog);
